import Model from 'cdna/core/model';

export default Model.extend({
    computed: {
        'sizeDescription FileSize': function(fileSize) {
            if (fileSize == -1) return 'unknown';

            var kb = fileSize / 1024;
            if (kb < 1) return fileSize.toString() + 'b';

            var mb = kb / 1024;
            if (mb < 1) return kb.toFixed(2).toString() + 'kb';

            return mb.toFixed(2).toString() + 'mb';
        }
    }
});


/** WEBPACK FOOTER **
 ** ./client/guide/guideEntryModel.js
 **/